import React, {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import {Section, Title} from "../../components/Common/PageElement";
import {Button, Col, Container, Modal} from "react-bootstrap";
import {Route, Switch, useHistory, useRouteMatch,} from "react-router-dom";
import Fade from "react-reveal/Fade";

import {Word2vecSearchRow} from "./StyledWord2vec";
import ButtonComponent from "../../components/ButtonComponent";
import {DropdownMenu, Textbox} from "../../components/Form";
import {
    ANNOTOOL_INTERMEDIATE,
    ANNOTREE_DATABASE,
    INTERMEDIATE_APPLICATION,
    MODEL_SELECTION,
    STOP_LOADER
} from "../../services/Constant";
import {LoadContext} from "../../context/LoadContext";
import {TokenService} from "../../services/Token";
import {GENE_CLUSTER_SEARCH, INTERMEDIATE_API, SERVER_URL, SIMILAR_WORDS,} from "../../services/Config";

import AutocompleteWithDebounce from "./Autocomplete";
import Intermediate from "./Intermediate";
import TextField from "@material-ui/core/TextField";
import './word2vec.css'
import PaginatedTableSimilarWords from "./WordsVisualizer/PaginatedTableSimilarWords";
import PaginatedTableSubsetWords from "./WordsVisualizer/PaginatedTableSubsetWords";


// Annotool search is used for gene cluster search and connect Annoview and Annotree
const Word2vec = () => {
    const tableRef = useRef(null);
    const { load,setLoad } = useContext(LoadContext);
    let { path } = useRouteMatch();
    let history = useHistory();


    // const [coverage, setCoverage] = useState('10000');
    const [topN, setTopN] = useState('30');

    const [databaseValue, setDatabaseValue] = useState(
        ANNOTREE_DATABASE[1]["id"]
    );

    const [modelValue, setModelValue] = useState(
        MODEL_SELECTION[0]["id"]
    );

    const [similarWords, setSimilarWords] = useState([])
    const [subsetMatch, setSubsetMatch] = useState([])
    // const test_data =
    //     [['PF04717 (Phage_base_V)'], ['PF04717 (Phage_base_V)', 'PF10106 (DUF2345)', 'PF13296 (T6SS_Vgr)'], ['PF04717 (Phage_base_V)', 'PF06715 (Gp5_C)'], ['PF04717 (Phage_base_V)', 'PF18946 (Apex)'], ['PF04717 (Phage_base_V)', 'PF18715 (Phage_spike)', 'PF18946 (Apex)'], ['PF04717 (Phage_base_V)', 'PF18715 (Phage_spike)']];
    const [idList, setIdList] = useState([]);

    const [maxLength,setMaxLength] = useState(0)
    const [resetPage,setResetPage] = useState(0)

    // **************************************************** divider ***************************************

    const [pageToken, setPageToken] = useState('')
    const genomeLimit = '10000';

    // **************************************************** divider ***************************************


    const isValidIntTopN = (str) => {
        const intVal = parseInt(str, 10);
        return Number.isInteger(intVal) && intVal >= 0
    };

    const updateIds = (newOptionList) =>{

        const ids = newOptionList.map(string => {
            // Splits the string at ' ---' and takes the first part
            // example: 'PF04000 --- Sas10/Utp3/C1D [Pfam]'
            return string.split('---')[0];
        });
        setIdList(ids)
    }

    const changeDatabaseValue = (e)=>{
        // console.log(e.target.value)
        setDatabaseValue(e.target.value)
    }

    const changeModelValue = (e)=>{
        // console.log(e.target.value)
        setModelValue(e.target.value)
    }

    const handleScroll = () => {
        const section = document.getElementById('app-container');
        if (section) {
            section.scrollIntoView({behavior: 'smooth'});
        }
    }

    const search = () => {

        // console.log(databaseValue)

        if(databaseValue === 'gtdb_archaea_r214'){
            alert('Archaea database is not available for now.')
            return

        }


        if(idList.length === 0){
            alert('please enter your ids')
            return
        }


        if (topN === "" || !isValidIntTopN(topN)) {
            alert('Please enter the correct top N value as an integer.')
            return
        }

        let intTopN = parseInt(topN)
        if(intTopN < 1 || intTopN > 50){
            alert('top N con only between 1 and 50')
            return
        }


        // const ids = idList.map(string => {
        //     // Splits the string at ' ---' and takes the first part
        //     // example: 'PF04000 --- Sas10/Utp3/C1D [Pfam]'
        //     return string.split('---')[0];
        // });

        const token = TokenService(40);

        setPageToken(token)
        // setLoad({'value':ANNOTOOL_INTERMEDIATE,'token':token,'database':databaseValue,'path':path});



        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", databaseValue);
        formData.append("ids", idList);
        formData.append("topn", topN);
        // formData.append("sequence_text", dataText);
        // formData.append("evalue", evalue);
        // formData.append("range", contextRange);
        // formData.append("limit", genomeLimit);


        axios
            .post(SERVER_URL + SIMILAR_WORDS, formData)
            .then((response) => {
                // console.log('get response')
                // setLoad({'value':STOP_LOADER,'token':''});


                const responseSimilarWords = response.data.similar_words
                const responseSubsetMatch = response.data.words_match

                if(responseSubsetMatch.length === 0){
                    alert('Current annotations are not available')
                    return
                }

                setSimilarWords(responseSimilarWords)
                setSubsetMatch(responseSubsetMatch)
                setResetPage((prevState)=>{
                    return prevState + 1
                })

                // console.log('submit success')
                // console.log(response.data)


            })
            .catch((e) => {
                console.log('word2vec error')
                console.log(e.response)
                // setLoad({'value':STOP_LOADER,'token':'','database':''});
                // if(e.response.status === 400){
                //     alert("Sorry no cluster found!");
                // }

                if(e.response.status === 400){
                    alert(e.response.data.error);
                }



            });
    };

    // useEffect(() => {
    //     console.log(similarWords,subsetMatch,tableRef)
    //     if (similarWords.length > 0 && subsetMatch.length > 0 && tableRef.current) {
    //         tableRef.current.scrollIntoView({ behavior: 'smooth' });
    //     }
    // }, [similarWords, subsetMatch]);

    const similarWordsRowsPerPage = 10;
    const subsetWordsRowsPerPage = 5;

    return (
        <Switch>
            <Route exact path={path}>
                {/*<Section height="full">*/}
                <Section >
                    <Container>
                        <Fade top duration={1000} delay={600} distance="15px">
                            {/*<Title>Annotree Search</Title>*/}
                            <Title>Semantic Analysis for Protein Domains</Title>
                        </Fade>

                        <Fade duration={1000} delay={600}>
                            <Word2vecSearchRow>
                                <Col>
                                    <AutocompleteWithDebounce
                                        updateIds={updateIds}
                                        database={databaseValue}
                                        curValue={idList}
                                    />

                                </Col>
                            </Word2vecSearchRow>
                            <Word2vecSearchRow>

                                <Col >
                                    <DropdownMenu
                                        options={ANNOTREE_DATABASE}
                                        val="id"
                                        label="name"
                                        formlabel="Database"
                                        // onChange={(event) =>
                                        //     setDatabaseValue(event.target.value)
                                        // }
                                        onChange={(event) =>
                                           changeDatabaseValue(event)
                                        }
                                        value={databaseValue}
                                    />
                                </Col>
                                <Col >
                                    <Textbox
                                        defaultvalue={topN}
                                        formlabel="Top similar words (between 1 and 50)"
                                        // formlabel={"Minimum query coverage of the alignment"}
                                        placeholder="Enter top n similar words (1 to 50)"
                                        onChange={(e) =>
                                            setTopN(e.target.value)
                                        }
                                        // showDetail={true}
                                    />
                                </Col>
                                <Col >

                                    <DropdownMenu
                                        options={MODEL_SELECTION}
                                        val="id"
                                        label="name"
                                        formlabel="Model"
                                        // onChange={(event) =>
                                        //     setDatabaseValue(event.target.value)
                                        // }
                                        onChange={(event) =>
                                            changeModelValue(event)
                                        }
                                        value={modelValue}
                                    />
                                </Col>
                            </Word2vecSearchRow>
                            <Word2vecSearchRow>

                                <Col md={{ span: 6, offset: 3 }}>

                                    <ButtonComponent
                                        fill
                                        disabled={
                                            idList.length === 0
                                        }
                                        onClick={search}
                                    >
                                        Search
                                    </ButtonComponent>
                                </Col>
                            </Word2vecSearchRow>

                            <hr className="divider" />

                            {
                                subsetMatch.length > 0 ?
                                    <Fade top duration={1000} delay={600} distance="15px">

                                        <div className="app-container">
                                            <div className="section">
                                                <h2>Proteins contain target annotation(s)</h2>
                                                <PaginatedTableSubsetWords data={subsetMatch} rowsPerPage={subsetWordsRowsPerPage} resetPage={resetPage}/>
                                            </div>

                                            <div className="section">
                                                <h2>Proteins with similar context</h2>
                                                <PaginatedTableSimilarWords data={similarWords} rowsPerPage={similarWordsRowsPerPage} resetPage={resetPage}/>
                                            </div>
                                        </div>

                                        <hr className="divider" />

                                    </Fade>:
                                    <div></div>
                            }



                        </Fade>



                    </Container>

                </Section>
                {/*<Fade distance="15px">*/}
                {/*    <PaginatedTable data={data} rowsPerPage={rowsPerPage} />*/}
                {/*    <hr className="divider" />*/}
                {/*</Fade>*/}

            </Route>



            {/*<Route path={`${path}/intermediate`}>*/}
            {/*    <Intermediate />*/}
            {/*</Route>*/}
        </Switch>
    );
};

export default Word2vec;